import type { DataErrorRepository } from '../data/data-error-repository';
import type { DeltaMeterValue } from '../types/data-error-types';

export class GetMeterValuesSurroundUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    meterValueId: number,
    machineId: number,
    surroundSize: number
  ): Promise<{ values: DeltaMeterValue[]; hasError: false } | { hasError: true; errorMessage: string }> {
    try {
      const values = await this.repository.getMeterValuesSurround(meterValueId, machineId, surroundSize);
      return { values, hasError: false };
    } catch (error: unknown) {
      return {
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to fetch meter values',
      };
    }
  }
}
